import { render, staticRenderFns } from "./FlexiInner.vue?vue&type=template&id=1369ed1a&scoped=true"
import script from "./FlexiInner.vue?vue&type=script&lang=js"
export * from "./FlexiInner.vue?vue&type=script&lang=js"
import style0 from "./FlexiInner.vue?vue&type=style&index=0&id=1369ed1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369ed1a",
  null
  
)

export default component.exports